import { legacy_createStore } from "redux";
import rootReducer from "./rootReducers";

const store = legacy_createStore(rootReducer);

export default store;
